import { SEO } from '@/components/base/SEO';
import { Navbar } from '@/components/feature/Navbar';
import { Footer } from '@/components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { CategoryCards } from './components/CategoryCards';
import { FeaturedArticles } from './components/FeaturedArticles';
import { FAQSection } from './components/FAQSection';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩国伦理网',
    url: 'https://korean-ethics.com',
    description: '深度解析韩国社会道德与价值观，全面探讨韩国伦理的核心内涵',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://korean-ethics.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩国伦理网',
    url: 'https://korean-ethics.com',
    description: '专注于韩国伦理文化研究与传播的知识平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@korean-ethics.com',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <SEO
        title="韩国伦理：深度解析韩国社会道德与价值观 | 韩国伦理网"
        description="韩国伦理网全面探讨韩国伦理的核心内涵，涵盖儒家思想对韩国伦理的深远影响、现代韩国社会的道德观念演变、职场伦理规范及家庭伦理文化，帮助您系统理解韩国伦理的独特体系与当代意义。"
        keywords="韩国伦理,韩国伦理文化,韩国社会道德观,韩国儒家伦理,韩国职场伦理,韩国家庭伦理,韩国传统价值观"
        canonicalUrl="https://korean-ethics.com/"
        ogTitle="韩国伦理：深度解析韩国社会道德与价值观 | 韩国伦理网"
        ogDescription="全面探讨韩国伦理的核心内涵，涵盖儒家思想、现代道德观念、职场伦理及家庭伦理文化"
        ogType="website"
        ogUrl="https://korean-ethics.com/"
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryCards />
        <FeaturedArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}